import { API } from "aws-amplify";

async function updateDetection(siteId: string, id: string, form: CreateTimeEntryForm, asCompany?: string): Promise<TimeEntry> {
  try {
    const path: string = `/attendance/${siteId}/${id}` + (asCompany ? `?asCompany=${asCompany}` : "");
    const options = {
      body: form
    };

    const data = await API.put(
      'api-service',
      path,
      options
    );

    return data.data as TimeEntry;
  } catch (error: any) {
    throw error;
  }
}

export default updateDetection;
